<div class="list-item-selector">
    <mmp5-search-suggest *ngIf="type == 'edit'" [fieldset]="true" [placeholder]="placeholder" [formControl]="formControl" [searchFn]="searchFn" (suggestionSelect)="addItem($event)" [key]="'list-item-picker-search'" [type]="'search'"></mmp5-search-suggest>
    <div class="list-items">
        <ng-scrollbar [appearance]="'compact'"  [visibility]="'always'">
            <ul class="list-ul">
                <li class="list-item" *ngFor="let item of items; let i = index">
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{item && item[attribute]}}</span>
                        <mmp5-mm-icons *ngIf="type == 'edit'" [icon]="['icon','icon-excluir']" (click)="remove(i)" class="text-danger icon-remove"></mmp5-mm-icons>
                    </div>
                </li>
            </ul>
        </ng-scrollbar>
        <div class="no-empty" *ngIf="items?.length == 0">
            <ng-content></ng-content>
        </div>
    </div>
</div>
